import { Container, Flex, Loader } from "@eworkit/iris";
import React, { FC } from "react";

import { EmptyList } from "@/components-new/lists";
import { InfiniteResultState } from "@/core/queries/useInfiniteQuery";
import { JobRequestListDto } from "@/data/job-requests/types/JobRequest";

import { DashboardJobsExpandableGrid } from "./DashboardJobsExpandableGrid";
import { DashboardJobsGrid } from "./DashboardJobsGrid";

export const STANDARD_VISIBLE_ROWS = 2;
export const GRID_COLUMNS = 4;

const STANDARD_VISIBLE_ELEMENTS = STANDARD_VISIBLE_ROWS * GRID_COLUMNS;
export const STANDARD_VISIBLE_HEIGHT = 320;

interface DashboardJobsGridRendererProps {
  query: InfiniteResultState<JobRequestListDto, unknown>;
  emptyHeader: string;
  emptySubheader: string;
}

export const DashboardJobsGridRenderer: FC<DashboardJobsGridRendererProps> = ({
  query,
  emptyHeader,
  emptySubheader,
}) => {
  if (query.isLoading) {
    return (
      <Container
        as={Flex}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: `${STANDARD_VISIBLE_HEIGHT}px` }}>
        <Loader size="xl" />
      </Container>
    );
  }

  if (query.data?.pages[0].totalElements == 0) {
    return (
      <Container
        as={Flex}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: `${STANDARD_VISIBLE_HEIGHT}px` }}>
        <EmptyList header={emptyHeader} subheader={emptySubheader} />
      </Container>
    );
  }

  return (
    <React.Fragment>
      {(query.data?.pages[0].totalElements ?? 0) > STANDARD_VISIBLE_ELEMENTS ? (
        <DashboardJobsExpandableGrid query={query} />
      ) : (
        <DashboardJobsGrid query={query} />
      )}
    </React.Fragment>
  );
};
